module.exports = __webpack_public_path__ + "img/icehockey.d7ee1b6d.svg";